module.exports = __webpack_public_path__ + "static/media/ellipsis-loader.7b335011.svg";